import * as React from "react";
import { v4 } from "uuid";

import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Badge from '@material-ui/core/Badge';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import CardHeader from '@material-ui/core/CardHeader';
import Avatar from '@material-ui/core/Avatar';

import "./../../resources/forest.jpg";

import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import Chip from '@material-ui/core/Chip';
import AlarmIcon from '@material-ui/icons/Alarm';
import AssignmentTurnedIn from '@material-ui/icons/AssignmentTurnedIn';
import PollIcon from '@material-ui/icons/Poll';

import { ThemeProvider, withTheme } from '@material-ui/core/styles';

import { createMuiTheme } from '@material-ui/core/styles';
import grey from '@material-ui/core/colors/grey';
import { ExerciseTask, TaskOption, Exercise, Execution } from '../server/ExamServer'
import ExamTask from "./ExamTask";
import ExamExercise from "./ExamExercise";
import CircularProgress from '@material-ui/core/CircularProgress';
import ExamExerciseResultList from "./ExamExerciseResultList";

import ExamServer from '../server/ExamServer'

import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

const theme = createMuiTheme({
    palette: {
        // primary: {
        //     main: '#44423e'
        // },
        // secondary: {
        //     main: '#FDC400',
        //     contrastText: '#fff'
        // }
    }

});



export interface AdminExecutionItemProps {

    // onFinished:() => void
    // onTimeExceeded:() => void

    exam: Execution
}

export interface AdminExecutionItemState {
    examResult: Execution | undefined
    open: boolean
    archived: boolean
    tabIndex: number
}


class AdminExecutionItem extends React.Component<AdminExecutionItemProps, AdminExecutionItemState> {

    server: ExamServer;
    constructor(props: AdminExecutionItemProps) {
        super(props);
        this.state = {
            examResult: undefined,
            open: false,
            archived: false,
            tabIndex: 0
        };

        this.server = new ExamServer()


    }

    handleToggleResult = () => {

        if (!this.state.open && this.state.examResult === undefined) {
            this.server.getExamResult(this.props.exam.id).then(examResult => {
                this.setState({
                    examResult
                })
            })
        }

        this.setState({ open: !this.state.open })
    }

    handleArchiving = () => {

        this.server.archiveExam(this.props.exam.id).then(examResult => {
            this.setState({ archived: true })
        })

        
    }

    render() {

        const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
            this.setState({ tabIndex: newValue });
        };

        return (
            // <React.Fragment>
            //     <Paper style={{marginTop:theme.spacing(5), padding :theme.spacing(3)}}>
            //         <Typography variant="h5" color="textPrimary" component="h5" gutterBottom>
            //             Name: {this.props.exam.name}
            //         </Typography>

            //         <Typography variant="subtitle1" color="textSecondary" component="p" gutterBottom>
            //             Room: {this.props.exam.classroom.name}
            //         </Typography>

            //         <Typography variant="subtitle1" color="textSecondary" component="p" gutterBottom>
            //             Finished: {this.props.exam.finished}
            //         </Typography>
            //     </Paper>
            // </React.Fragment>


            <Card style={{ marginTop: theme.spacing(3) }}>
                <CardActionArea>
                    <CardHeader
                        avatar={
                            <Avatar color={"secondary"}>
                                <PollIcon />
                            </Avatar>
                        }
                        title={<Typography variant="body2" color="textPrimary" component="h5" gutterBottom>
                                {this.props.exam.name + "  - " + this.props.exam.classroom.name}
                            </Typography>}
                        subheader={(new Date(parseInt(this.props.exam.time.toString())).toLocaleString())}
                    />
                </CardActionArea>
                {!this.state.archived && this.state.open ? (
                    <CardContent style={{ backgroundColor: grey[100] }}>

                        <Paper >
                            <Tabs
                                onChange={handleChange}
                                value={this.state.tabIndex}
                                // indicatorColor="primary"
                                // textColor="primary"
                                centered
                            >
                                <Tab label="Result Overview" />
                                <Tab label="Result Details" />
                            </Tabs>

                        </Paper>


                        {this.state.tabIndex === 0 && this.state.examResult && this.state.examResult.examination.exercises.map(exercise => {
                            return <ExamExerciseResultList exercise={exercise} />
                        })}
                        {this.state.tabIndex === 1 && this.state.examResult && this.state.examResult.examination.exercises.map(exercise => {
                            return <ExamExercise exercise={exercise} onSelect={() => { }} />
                        })}

                    </CardContent>) : null}

                    {this.state.archived && (<CardContent style={{ backgroundColor: grey[100] }}>This exam is archived</CardContent>)}

                    {!this.state.archived && this.props.exam.finished && (
                        <CardActions>
                            {this.state.open ? (
                                <Button size="small" color="secondary" onClick={this.handleToggleResult}>
                                    Close Results
                                </Button>
                            ) : (

                                    <Button size="small" color="primary" onClick={this.handleToggleResult}>
                                        Show Result
                                    </Button>

                                )}
                                <Button size="small" color="primary" onClick={this.handleArchiving}>
                                    Remove and Archive
                                </Button>
                        </CardActions>)}
                        
                        
                        {!this.state.archived && !this.props.exam.finished && (
                            <CardContent>
                                <Typography variant="body2" color="textSecondary" component="h5" gutterBottom>
                                    Test currently in progress...
                                </Typography>
                            </CardContent>
                        )}
                    
            </Card>

        );
    }
}

export default AdminExecutionItem;
